import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "@/lib/api";
import { CheckCircle2 } from "lucide-react";
import { BrandMark, PoweredBy } from "@/components/candidate/CandidateBrand";

export default function DoneRoom() {
  const { token } = useParams();
  const [inv, setInv] = useState(null);
  useEffect(() => { api.get(`/invite/${token}`).then(r => setInv(r.data)).catch(()=>{}); }, [token]);
  const cand = inv?.candidate;
  const company = inv?.tenant?.name;
  return (
    <div className="tp-portal min-h-screen flex flex-col" data-testid="done-page">
      <div className="flex-1 grid place-items-center p-6">
        <div className="tp-card p-10 max-w-lg text-center">
          {inv?.tenant && <div className="flex justify-center mb-6"><BrandMark tenant={inv.tenant} light /></div>}
          <div className="w-14 h-14 rounded-full bg-emerald-100 grid place-items-center mx-auto mb-4">
            <CheckCircle2 className="w-8 h-8 text-emerald-600"/>
          </div>
          <h1 className="font-display text-2xl font-bold text-slate-900 mb-2" data-testid="done-title">
            {company ? `Thanks for interviewing with ${company}` : "Thanks"}{cand ? `, ${cand.name}` : ""}!
          </h1>
          <p className="text-slate-500 leading-relaxed">Your interview has been submitted for review. {company ? `The ${company} hiring team` : "The hiring team"} will be in touch with next steps shortly. You can safely close this tab.</p>
        </div>
      </div>
      <PoweredBy light />
    </div>
  );
}
